let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("etwBB")).then(() => parcelRequire('7x9yK'));